import type { GlobalFilters } from '@aurora-pvi/contracts';

/**
 * `GlobalFilters` as query parameters.
 *
 * One writer, so every route reads the same names. Arrays are repeated keys
 * (`?productIds=a&productIds=b`) rather than a comma-joined string: a product
 * name is free text and could contain a comma, and a delimiter that can appear
 * inside a value is a parsing bug waiting for the right record.
 *
 * Empty arrays and empty strings are omitted rather than sent blank, so
 * "filter cleared" and "filter set to nothing" cannot arrive looking alike.
 */

const ARRAY_KEYS = [
  'departmentIds',
  'valueStreamIds',
  'productGroupIds',
  'productIds',
  'ownerIds',
  'health',
  'lifecycle',
  'classification',
] as const;

const SCALAR_KEYS = [
  'scopeId',
  'periodStart',
  'periodEnd',
  'comparison',
  'asOf',
  'scenarioId',
  'search',
] as const;

export function filterParams(filters: GlobalFilters, into = new URLSearchParams()): URLSearchParams {
  for (const key of SCALAR_KEYS) {
    const value = filters[key];
    if (typeof value === 'string' && value.trim() !== '') into.set(key, value.trim());
  }
  for (const key of ARRAY_KEYS) {
    for (const value of filters[key] ?? []) {
      if (value !== '') into.append(key, value);
    }
  }
  return into;
}
